// Lifted (trylifted.ai) watches billing read-only: it counts visitors who see
// a price and ties each new subscription back to that visit. The script is
// loaded async in pages/_document.js with data-visits="manual", so it counts
// nothing by itself and changes nothing on the page. Either call is a no-op
// when it is blocked or hasn't loaded.

type Lifted = { visit?: () => unknown };

const lifted = (): Lifted | undefined =>
  typeof window === "undefined"
    ? undefined
    : (window as unknown as { lifted?: Lifted }).lifted;

// Count a visit where a price is seen. The script is async, so on a page that
// shows prices straight away (/pricing) it may not have run yet: count once
// it loads.
export function countPriceView() {
  if (typeof window === "undefined") return;
  if (lifted()) {
    lifted()?.visit?.();
    return;
  }
  document
    .querySelector('script[src^="https://trylifted.ai/"]')
    ?.addEventListener("load", () => lifted()?.visit?.(), { once: true });
}

// Sent with createSubscriptionIntent and stored on the subscription. Falls
// back to the ID in localStorage (or makes it) when the script hasn't run.
export { liftedVisitor } from "../../../packages/ui/api/src/payments/lifted";
